import Spinner from '@/common-utils/components/renders/spinner/Spinner';
import ICONS from '../../../../../../enums/icons';
import { Button } from '../../../../../ui/button';
import { ModalClose, ModalFooter } from '../../../../../ui/modal';
import PropTypes from 'prop-types';

const FooterForm = ({ onReset, onSubmit, isSubmitDisabled, isSubmitting, showSubmitButton = true }) => {
    return (
        <ModalFooter>
            {isSubmitting && <Spinner className='form-spinner' />}
            {onReset &&
                <Button
                    entity={'button.reset'}
                    variant='secondary'
                    size='auto'
                    icon={ICONS.RESET}
                    onClick={onReset}
                    disabled={isSubmitting}
                />
            }
            {
                // Bouton dans Bouton = erreur à corriger
            }
            <ModalClose asChild>
                <Button
                    entity={'button.close'}
                    variant='secondary'
                    size='auto'
                    icon={ICONS.CLOSE}
                    disabled={isSubmitting}
                />

            </ModalClose>
            {showSubmitButton &&
                <Button
                    type='submit'
                    entity={'button.submit'}
                    variant='primary'
                    size='auto'
                    icon={ICONS.VALIDATE}
                    onClick={onSubmit}
                    disabled={isSubmitDisabled || isSubmitting}
                />
            }
        </ModalFooter>
    );
};

FooterForm.propTypes = {
    onReset: PropTypes.func,
    onSubmit: PropTypes.func,
    isSubmitDisabled: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    showSubmitButton: PropTypes.bool
};

export default FooterForm;